import { AppShell as MAppShell } from '@mantine/core';
import classes from './appshell.module.scss';

export const AppShell = MAppShell.extend({
  classNames: classes,
});
